import { render, staticRenderFns } from "./TaskDetailModal.vue?vue&type=template&id=54b649a9&scoped=true"
import script from "./TaskDetailModal.vue?vue&type=script&lang=js"
export * from "./TaskDetailModal.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailModal.vue?vue&type=style&index=0&id=54b649a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b649a9",
  null
  
)

export default component.exports